module.exports = __webpack_public_path__ + "static/media/Residential_12.9d2c5a17.jpg";